import { Field } from "formik";
import { Form } from "react-bootstrap";
import * as Yup from "yup";
// SubForms
import { NameAndContactSubForm, Schema as NameAndContactSchema } from '../subforms/NameAndContact';
import { EntranceDateSubForm } from '../subforms/EntranceDate';
import { OtherInformationSubForm, Schema as OtherInformationSchema } from '../subforms/OtherInformation';
import { SalaryRequestSubForm, Schema as SalaryRequestSchema } from '../subforms/SalaryRequest';
import { DocumentsSubForm, Schema as DocumentsSchema } from '../subforms/Documents';

export const AtlasStandardSchema = (settings) => (
    Yup.object()
        .concat(NameAndContactSchema(settings))
        .concat(SalaryRequestSchema)
        .concat(OtherInformationSchema)
        .concat(DocumentsSchema(settings))
);

export const AtlasStandard = (props) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Text muted>Alle mit * gekennzeichneten Felder sind Pflichtfelder und müssen ausgefüllt werden.</Form.Text>
            <Field component={NameAndContactSubForm} colors={colors} settings={settings} />
            <Field component={SalaryRequestSubForm} colors={colors} />
            <Field component={EntranceDateSubForm} colors={colors} settings={settings} />
            <Field component={OtherInformationSubForm} colors={colors} />
            <Field component={DocumentsSubForm} colors={colors} settings={settings} />
        </>
    );
}